import {BaseEvent} from "./BaseEvent";

export class EditModeEvent extends BaseEvent {
  public static NAME = 'editMode';

  isEditMode: boolean = false;

  constructor(isEditMode: boolean) {
    super(EditModeEvent.NAME);
    this.isEditMode = isEditMode;
  }
}
